
modal = (function() {
  var _this = {
    
    cookieKey:'show_spinner120522a',
    close: function() {
      var $cur = $.featherlight.current()
      if ($cur != null) {
        $cur.close()
      }
    },
    
    setCookie:function(){
       $.cookie(_this.cookieKey, true, {
         expires: 7,
         path: '/'
       })
    },

    spinner: {
      init: function(settings) {
        _this.settings = settings
        if (!$.cookie(_this.cookieKey)) {
          $('.cta-mspin').show()
        }
      },
      
      show: function() {
        _this.settings.customElement.render()
        $('.cta-mspin').hide()
        $.featherlight($('[data-modal="spinner"]'), {
          afterOpen: function() {
            if(!_this.isBound){
              _this.isBound = true
              if(_this.settings.omnisend){
                $('.featherlight-content .js-m-spinner-nl-form').omnisendForm({
                  onAdded:function(){
                    _this.close()
                    _this.setCookie()
                  }
                })
              }else{
                KlaviyoSubscribe.attachToForms('.featherlight-content .js-m-spinner-nl-form', {
                  success: function() {
                    _this.close()
                    _this.setCookie()
                  },
                })
              }
            }
          }
        })
        
        $(document).on('click', '[data-spinner="close"]', function(e) {
          e.preventDefault()
          _this.close()
          _this.setCookie()
        })
        
        $(document).on('click', '[data-spinner="spin"]', function(e) {
          e.preventDefault()
          _this.spinner.spin()
        })
      
      },

      spin: function() {
        $('.m-spinner__main--game').addClass('__is-clicked')
        setTimeout(function() {
          $('.m-spinner__main--game').fadeOut(200, function() {
            $('.m-spinner__main--prize').fadeIn(200)
          })
        }, 4000)
      }
    }
  }

  $(document).on('click', '.js-show_spinner', function(e) {
    e.preventDefault()
    _this.spinner.show()
  })
  
  return _this
})();
 


